import "../assets/Home.scss";

import { Col, Divider, Flex, Row, Tag, Typography } from "antd";
import { isNowOpen, workingHours } from "../utils/getWorkingHours";
import { useState } from "react";

import ButtonRdv from "./ButtonRdv";
import CallModal from "./CallModal";
import {
    ClockCircleOutlined,
    SafetyCertificateOutlined,
    ReadOutlined,
    MedicineBoxOutlined,
    ExperimentOutlined,
    PhoneOutlined,
} from "@ant-design/icons";
import hero from "../assets/hero.jpg";

const MATERNITY_END = new Date(2026, 4, 19);
const isMaternityLeave = new Date() < MATERNITY_END;

// index 0=Lundi ... 6=Dimanche
const DOCTOR_BY_DAY: Record<number, 'boulanger' | 'mejani' | null> = {
    0: 'boulanger',
    1: 'boulanger',
    2: 'mejani',
    3: 'boulanger',
    4: 'mejani',
    5: null,
    6: null,
};

// Pastille d'état « ouvert / fermé » en direct, calculée à partir des horaires.
function OpenStatus() {
    const open = isNowOpen();
    return (
        <div className={`openStatus ${open ? "isOpen" : "isClosed"}`} role="status">
            <span className="statusDot" aria-hidden="true" />
            {open ? "Cabinet ouvert actuellement" : "Cabinet actuellement fermé"}
        </div>
    );
}

export default function Home() {
    const [callModalOpen, setCallModalOpen] = useState(false);
    // const today = new Date();

    // const isTodayHoliday = holidays.some(holiday => {
    //     const fromDate = new Date(today.getFullYear(), holiday.from.month, holiday.from.day);
    //     const toDate = new Date(today.getFullYear(), holiday.to.month, holiday.to.day);
    //     return today >= fromDate && today <= toDate;
    // });
    return (
        <section className="siteContent">
            <CallModal open={callModalOpen} onClose={() => setCallModalOpen(false)} />
            <div className="profileHero">
                <button
                    type="button"
                    className="heroImageWrap"
                    onClick={() => setCallModalOpen(true)}
                    aria-label="Prendre un rendez-vous avec le Dr Boulanger"
                >
                    <video
                        className="heroImage"
                        src={`${process.env.PUBLIC_URL}/docteur-boulanger.mp4`}
                        poster={hero}
                        autoPlay
                        loop
                        muted
                        playsInline
                        preload="metadata"
                        aria-hidden="true"
                    />
                    <span className="heroBadge">
                        <SafetyCertificateOutlined /> Médecin agréée &amp; accréditée
                    </span>
                    <span className="heroCta">
                        <PhoneOutlined /> Prendre un rendez-vous
                    </span>
                </button>

                <ul className="credentials" aria-label="Qualifications et expertise">
                    <li>
                        <span className="credIcon"><SafetyCertificateOutlined /></span>
                        <span className="credText">
                            <strong>Agréée &amp; accréditée</strong>
                            <span>Médecin généraliste</span>
                        </span>
                    </li>
                    <li>
                        <span className="credIcon"><ReadOutlined /></span>
                        <span className="credText">
                            <strong>Membre SSMG</strong>
                            <span>Société scientifique de médecine générale</span>
                        </span>
                    </li>
                    <li>
                        <span className="credIcon"><MedicineBoxOutlined /></span>
                        <span className="credText">
                            <strong>Médecine d’urgence</strong>
                            <span>5 ans en milieu hospitalier</span>
                        </span>
                    </li>
                    <li>
                        <span className="credIcon"><ExperimentOutlined /></span>
                        <span className="credText">
                            <strong>Nutrition</strong>
                            <span>Approche globale de la santé</span>
                        </span>
                    </li>
                </ul>
            </div>

            <div className="lead">
                <p>Diplômée en 2015, j’ai travaillé en médecine générale en milieu rural pendant 3 ans. J’ai ensuite travaillé dans un service d’urgences en milieu hospitalier durant 5 ans. J’y ai ’acquis une solide connaissance des pathologies aiguës et des urgences médico-chirurgicales. J’ai aussi une bonne connaissance en nutrition...</p>
                <p>En tant que généraliste, j’aime le côté humain de la médecine de famille et ma préoccupation est votre santé.</p >
                <p>Je serai heureuse de vous accueillir sur rendez - vous selon les horaires repris ci - dessous.</p >
            </div>
            <Divider />
            <Row gutter={[0, 30]}>
                <Col span={24} style={{ textAlign: 'center' }}>
                    <Typography.Title level={2}><ClockCircleOutlined /> Horaires de consultation</Typography.Title>
                    <OpenStatus />
                    <div className="weekGrid">
                        {workingHours.map((day, index) => {
                            const isToday = new Date().getDay() - 1 === index;
                            const isFullyClosed = !day.open && !day.availableByPhone;
                            const doctor = DOCTOR_BY_DAY[index];
                            return (
                                <div
                                    key={index}
                                    className={`dayCard${isToday ? ' isToday' : ''}${isFullyClosed ? ' isClosed' : ''}`}
                                >
                                    <span className="dayName">{day.day}</span>
                                    {doctor !== null && (
                                        isMaternityLeave || doctor === 'mejani'
                                            ? <Tag color="purple" style={{ margin: 0 }}>Dr. Mejani</Tag>
                                            : <Tag color="blue" style={{ margin: 0 }}>Dr. Boulanger</Tag>
                                    )}
                                    <span className="dayHours">
                                        {day.open ? `${day.start}h – ${day.end}h` : 'Fermé'}
                                    </span>
                                    {day.message && <span className="dayMessage">{day.message}</span>}
                                </div>
                            );
                        })}
                    </div>
                </Col>
                <Col lg={24} xs={24}>
                    <Flex vertical gap="middle" align="center">

                        <Typography.Title level={2}><ClockCircleOutlined /> Fermetures</Typography.Title>
                        {/* {holidays.map((holiday, index) => {
                            const formattedFromDay: string = holiday.from.day === 1 ? 'er' : '';
                            const formattedToDay: string = holiday.to.day === 1 ? 'er' : '';
                            const isHolidayToday = new Date(today.getFullYear(), holiday.from.month, holiday.from.day) <= today &&
                                new Date(today.getFullYear(), holiday.to.month, holiday.to.day) >= today;

                            return (
                                <Typography.Paragraph key={index}>
                                    {(holiday.from.day === holiday.to.day) && (holiday.from.month === holiday.to.month)
                                    ? `Le ${holiday.from.day}${formattedFromDay} ${getFrenchMonth(holiday.from.month)}`
                                    : `Du ${holiday.from.day}${formattedFromDay} ${getFrenchMonth(holiday.from.month)} au ${holiday.to.day}${formattedToDay} ${getFrenchMonth(holiday.to.month)}`
                                }
                                {isHolidayToday && <Tag color="red" style={{ marginLeft: '10px' }}>Fermeture actuelle</Tag>}
                                </Typography.Paragraph>
                            )
                        })} */}
                        <Typography.Text strong>Pour tout renseignement concernant les périodes d’absence et de vacances, je vous invite à me poser la question directement et/ou à consulter régulièrement et attentivement le message de mon répondeur.</Typography.Text>
                        <ButtonRdv type="primary" />
                    </Flex>
                </Col>
            </Row>


            <Divider />
            <Typography.Title level={2}>Votre santé, ma préoccupation</Typography.Title>
            <p>En tant que médecin généraliste, je m’engage à :</p>
            <ul className="withBullet">
                <li><span>Être directement accessible</span></li>
                <li><span>Communiquer avec les patients et aussi avec mes confrères et mes consœurs généralistes et spécialistes sans oublier les paramédicaux</span></li>
                <li><span>Dispenser des soins de qualité basé sur des preuves scientifiques</span></li>
                <li><span>Effectuer une synthèse de toutes les variables de votre santé pour déterminer des priorités</span></li>
                <li><span>Utiliser le dossier médical global.</span></li>
            </ul>
            <p>Ensemble, nous nous occuperons de vos problèmes de santé dans une vision holistique. Ma tâche principale consistera à vous écouter et à vous interroger afin de comprendre ensemble, vos plaintes. L’examen clinique est une étape nécessaire et essentielle. La consultation se terminera éventuellement par la prescription pour des examens complémentaires afin d’affiner un diagnostic. Il s’agira ensuite d’instaurer un traitement.</p>
            <p>Le médecin généraliste occupe une place essentielle au sein du réseau de soins. Il a une bonne connaissance de son patient et de sa patiente, de son histoire, de sa famille et de son contexte de vie.</p>
            <p>Je suis membre de la <a href="https://www.ssmg.be/" target="_blank" rel="noreferrer">Société scientifique de médecine générale de Belgique</a>. Même après plusieurs années de formation, je continue à m’informe et à suivre une formation continuée.</p>
            <p>En tant que médecin généraliste, je me dois de respecter la déontologie c'est-à-dire l’ensemble des règles et devoirs inhérents à l’exercice de ma profession. Je respecte aussi l’éthique c'est-à-dire je communique des informations sérieuses et validées, indépendantes de tout finalité commerciale.</p>
            <ButtonRdv type="primary" />

            <Divider />
            <Typography.Title level={2}>Questions fréquentes</Typography.Title>
            <div className="faq">
                <div className="faqItem">
                    <Typography.Title level={3}>Comment prendre rendez-vous avec le Dr Boulanger ?</Typography.Title>
                    <p>Les consultations se font uniquement sur rendez-vous. Vous pouvez appeler le cabinet au <a href="tel:+32492666667">+32 492 66 66 67</a> pendant les heures d’ouverture, du lundi au vendredi de 8h à 18h.</p>
                </div>

                <div className="faqItem">
                    <Typography.Title level={3}>Où se situe le cabinet du Dr Boulanger ?</Typography.Title>
                    <p>Le cabinet est situé Rue Hélène de Visscher 1, 5004 Bouge (Namur), en Belgique.</p>
                </div>

                <div className="faqItem">
                    <Typography.Title level={3}>Quels sont les horaires de consultation ?</Typography.Title>
                    <p>Le cabinet est ouvert du lundi au vendredi, de 8h à 18h, sur rendez-vous. Il est fermé le samedi et le dimanche.</p>
                </div>

                <div className="faqItem">
                    <Typography.Title level={3}>Le cabinet accepte-t-il de nouveaux patients ?</Typography.Title>
                    <p>Oui, le Dr Elisabeth Boulanger accepte de nouveaux patients et peut ouvrir un dossier médical global (DMG).</p>
                </div>
            </div>

        </section>
    )
}
